import { useEffect, useRef, useState } from 'react'

/** An element's content-box size, kept current by a ResizeObserver (the prototype redraws on resize). */
export function useBoxSize<T extends HTMLElement>() {
  const ref = useRef<T | null>(null)
  const [size, setSize] = useState({ width: 0, height: 0 })
  useEffect(() => {
    const el = ref.current
    if (el === null) return
    const read = () => setSize((prev) => prev.width === el.clientWidth && prev.height === el.clientHeight
      ? prev : { width: el.clientWidth, height: el.clientHeight })
    read()
    if (typeof ResizeObserver === 'undefined') return
    const observer = new ResizeObserver(read)
    observer.observe(el)
    return () => observer.disconnect()
  }, [])
  return [ref, size] as const
}
